import { basicInfoAtom } from "@/atoms";
import { recordStorefrontEvent } from "@/domain/storefront-analytics";
import { useBrowsingChannelCatalog } from "@/hooks/use-browsing-channel-catalog";
import { EmptyState, PageContainer } from "@/components/ui";
import { MenuMode } from "@/lib";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { ImageMenu } from "./image-menu";
import { ListMenu } from "./list-menu";

export function Home() {
  const basicInfo = useAtomValue(basicInfoAtom)
  const {
    isTableMode,
    service,
    menu,
    categories,
    itemNames,
  } = useBrowsingChannelCatalog()

  useEffect(() => {
    if (service && menu) recordStorefrontEvent({ type: "menu_view" })
  }, [service, menu])

  if (!basicInfo) throw new Error("Basic info not found")

  if (!service) {
    if (isTableMode) {
      return (
        <PageContainer>
          <EmptyState
            size="section"
            className="min-h-empty justify-center"
            title="Cardápio de mesa indisponível"
            description="Este estabelecimento ainda não habilitou o consumo no local."
          />
        </PageContainer>
      )
    }
    throw new Error("Delivery service not found")
  }

  return menu?.menuMode === MenuMode.PRODUCT_LIST
    ? (
      <ListMenu
        basicInfo={basicInfo}
        itemNames={itemNames}
        deliveryService={service}
      />
    )
    : (
      <ImageMenu
        basicInfo={basicInfo}
        categories={categories}
        itemNames={itemNames}
        deliveryService={service}
      />
    )
}
